<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" ref="searchForm" label-width="90px">
          <el-form-item label="SPU名称" prop="spuName">
            <el-input v-model.trim="searchForm.spuName" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="SKU编码" prop="skuCode">
            <el-input v-model.trim="searchForm.skuCode" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="SKU名称" prop="skuName">
            <el-input v-model.trim="searchForm.skuName" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="产品编码" prop="productCode">
            <el-input v-model.trim="searchForm.productCode" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="productName">
            <el-input v-model.trim="searchForm.productName" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="SKU进度" prop="taskNameList">
            <el-select v-model="searchForm.taskNameList" placeholder="请选择" filterable multiple collapse-tags @change="taskNameListChange">
              <el-option label="全部" value="" v-if="!all"></el-option>
              <el-option label="取消所有" value="cancleAll" v-else></el-option>
              <el-option v-for="item in serviceUserJobList" :key="item.taskName" :label="item.taskName" :value="item.taskName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型" prop="dataType">
            <el-select v-model="searchForm.dataType" placeholder="请选择" filterable clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in ['拍摄', '渲染']" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="SPU编码" prop="spuCode">
            <el-input v-model="searchForm.spuCode" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="importExcel">导入</el-button>
        <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
      </template>
      <el-table :data="tableData.records" ref="tableRef" border :height="maxTableHeight" @sort-change="handleSortChange" v-loading="loading">
        <el-table-column
          v-for="(item, index) in columnData"
          :key="index"
          :sortable="item.sortable ? 'custom' : false"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            {{ scope.row[item.columnName] }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row }">
            <el-button type="text" @click="edit(row)" :disabled="row.taskName == '准备上架' || row.taskName=='完成上架'">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
            background
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <edit-dialog :visible.sync="dialogVisible" v-if="dialogVisible" :rowData="rowData" :columnData="columnData" @success="onSearch" />
  </content-panel>
</template>

<script>
import axios from "@/utils/axiosInstance";
import tableMixin from "@/utils/tableMixin";
import editDialog from "./edit.vue";
import moment from "moment";
import pagePathMixin from '@/utils/page-path-mixin'

export default {
  name: "PreliminaryReview",
  mixins: [tableMixin, pagePathMixin],
  components: { editDialog },
  data() {
    return {
      searchForm: {
        spuName: "",
        skuCode: "",
        skuName: "",
        productCode: "",
        productName: "",
        dataType: "",
        taskNameList: [],
        spuCode: ""
      },
      tableHeight: 0,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogVisible: false,
      rowData: {},
      loading: false,
      all: false,
      searchFormData: {},
      imgList: [],
      columnData: [],
      orderDto: {},
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      //岗位
      serviceUserJobList: [],
      dialogType: 1,
    };
  },
  computed: {},
  mounted() {
    this.getserviceUserJobList();
  },
  methods: {
    onSearch() {
      this.$refs.tableRef.clearSort();
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let registerDate = this.searchForm.registerDate;
      let employDateQuery = this.searchForm.employDateQuery;
      let data = {
        ...this.searchForm,
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        registerDateStart: registerDate && registerDate.length ? registerDate[0] : "",
        registerDateEnd: registerDate && registerDate.length ? registerDate[1] : "",
        employDateQueryStart: employDateQuery && employDateQuery.length ? employDateQuery[0] : "",
        employDateQueryEnd: employDateQuery && employDateQuery.length ? employDateQuery[1] : "",
        customerIdList: this.searchForm.customerIdList ? this.searchForm.customerIdList.split(" ") : [],
        ...this.orderDto,
      };
      this.searchFormData = data;
      this.$q.dataImport
        .shootingTypeSearch({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.columnData = res.data.titleList.map((v) => {
              return {
                ...v,
                displayName: v.titleName,
                columnName: v.propertyName,
                displayWidth: "150px",
                sortable: v.sortable == 1 ? "custom" : false,
                span: false,
                freezeType: v.fixed == "1" ? "left" : false,
              };
            });
            // this.dynamicCustomColumn();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(true);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(true);
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.$refs.searchForm.resetFields();
      this.$set(
        this.searchForm,
        "taskNameList",
        this.serviceUserJobList.filter((v) => v.taskName != "完成上架" && v.taskName != "准备上架").map(v=>v.taskName)
      );
      this.taskNameListChange(this.searchForm.taskNameList)
      this.onSearch();
    },
    handleSortChange({ column, prop, order }) {
      let type = order === "ascending" ? "0" : order === "descending" ? "1" : false;
      this.tableData.pageNum = 1;
      this.orderDto = {
        sortField: prop,
        sortOptions: order === "ascending" ? "0" : order === "descending" ? "1" : "",
      };
      this.orderDto = type ? this.orderDto : {};
      this.init();
    },
    edit(row) {
      this.rowData = { ...row };
      this.dialogVisible = true;
    },
    taskNameListChange(val) {
      this.all = val.length == this.serviceUserJobList.length
      if(val.includes("")) {
        this.searchForm.taskNameList = this.serviceUserJobList.map(v=>v.taskName)
        this.all = true
      } else if (val.includes("cancleAll")) {
        this.searchForm.taskNameList = [];
        this.all = false;
      }
    },
    //导入
    importExcel() {
      this.openSubPage({
        path: "/shootingTypeImport",
        query: {
          fileName: "拍摄类型导入.xlsx",
          appCode: "ec-pc-new",
          reportName: "qualityCheckAuditInfoImport",
        },
      });
    },
    // 导出
    exportExcel(val) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let data = {
        ...this.searchFormData,
      };
      this.$q.dataImport.shootingTypeExport({ data: data, options: { responseType: "blob" } }).then((res) => {
        loading.close();
        let fileName = "拍摄类型导入" + moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        this.blobDownload(res, `${fileName}.XLSX`);
      });
    },
    async downloadRes(url, fileName) {
      let response = await fetch(url, { mode: "cors" });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName + "" + url.substring(url.lastIndexOf("."));
      a.click();
      a.remove();
    },
    //sku进度
    getserviceUserJobList() {
      let data = JSON.parse(JSON.stringify(this.currencyForm));
      data.reportCode = "newProductSkuTaskNameList";
      axios.post(`/ec-pc-api/custom/reports/data/newProductSkuTaskNameList`, data).then((res) => {
        if (res.code == 200) {
          this.serviceUserJobList = res.data.list;
          this.$set(
            this.searchForm,
            "taskNameList",
            this.serviceUserJobList.filter((v) => v.taskName != "完成上架" && v.taskName != "准备上架").map(v=>v.taskName)
          );
          this.taskNameListChange(this.searchForm.taskNameList)
          this.onSearch();
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
body {
  height: auto !important
}
.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
